// #region Import
import mitt from "../mitt";
import { reactive } from 'vue';
import NotEqualsValidationRule from "./rules/notequals.rule";
import EqualsValidationRule from "./rules/equals.rule";
import IsInValidationRule from "./rules/isin.rule";
import LengthValidationRule from "./rules/length.rule";
import MaxLengthValidationRule from "./rules/maxlength.rule";
import MinLengthValidationRule from "./rules/minlength.rule";
import RegExpValidationRule from "./rules/regexp.rule";
import RequiredValidationRule from "./rules/required.rule";
import TypeValidationRule from "./rules/type.rule";
import MinCountValidationRule from "./rules/mincount.rule";
import MaxCountValidationRule from "./rules/maxcount.rule";
// #endregion
export default class ValidationManager {
    // #region Vars
    _component;
    _data = {};
    _eventBus;
    _rules;
    _Validator = new Map();
    // #endregion
    // #region Properties
    get rules() {
        return this._rules;
    }
    get data() {
        return this._data;
    }
    get eventBus() {
        return this._eventBus;
    }
    // #endregion
    // #region Constructor
    constructor(component) {
        //Vars        
        this._component = component;
        this._rules = reactive({});
        this._eventBus = mitt();
        //Validator
        this.registerValidator(new NotEqualsValidationRule());
        this.registerValidator(new RequiredValidationRule());
        this.registerValidator(new TypeValidationRule());
        this.registerValidator(new EqualsValidationRule());
        this.registerValidator(new MinLengthValidationRule());
        this.registerValidator(new MaxLengthValidationRule());
        this.registerValidator(new LengthValidationRule());
        this.registerValidator(new RegExpValidationRule());
        this.registerValidator(new IsInValidationRule());
        this.registerValidator(new MinCountValidationRule());
        this.registerValidator(new MaxCountValidationRule());
    }
    // #endregion
    // #region Boostrap
    setData(data) {
        //Data
        this._data = data;
        //Field
        Object.keys(this._rules).forEach(e => {
            this._rules[e].updateValue();
        });
    }
    registerValidator(validator) {
        this._Validator.set(validator.name, validator);
    }
    registerField(field) {
        // #region Check
        if (utils.isNullOrEmpty(field.dataMember)) {
            return;
        }
        if (utils.isNullOrEmpty(field.validationRules)) {
            return;
        }
        // #endregion
        // #region Rule (Array)
        if (utils.isArray(field.validationRules)) {
            //Vars
            let tRules = field.validationRules;
            let tMember = field.dataMember;
            //Build
            tRules.forEach(r => {
                let tRule = {
                    name: r.name,
                    props: r.props,
                };
                if (this._rules[tMember] === undefined) {
                    this._rules[tMember] = {
                        name: tMember,
                        displayName: utils.trimChar(field?.label, '*') ?? tMember,
                        isValidated: false,
                        isValid: false,
                        getValue: () => { return field.internalValue; },
                        updateValue: () => { field.updateInternalValue(); },
                        setValidation: () => {
                            field.errorMessage = this.message(field.dataMember);
                        },
                        rules: [],
                    };
                }
                this._rules[tMember].rules.push(tRule);
            });
        }
        // #endregion
        // #region Rule
        else {
            //Vars
            let tRules = field.validationRules;
            let tMember = field.dataMember;
            //Build
            Object.keys(tRules).forEach((e) => {
                let tRule = {
                    name: e,
                    props: tRules[e],
                };
                if (this._rules[tMember] === undefined) {
                    this._rules[tMember] = {
                        name: tMember,
                        displayName: utils.trimChar(field?.label, '*') ?? tMember,
                        isValidated: false,
                        isValid: false,
                        getValue: () => { return field.internalValue; },
                        updateValue: () => { field.updateInternalValue(); },
                        setValidation: () => {
                            field.errorMessage = this.message(field.dataMember);
                        },
                        rules: [],
                    };
                }
                this._rules[tMember].rules.push(tRule);
            });
        }
        // #endregion
    }
    unregisterField(field) {
        // #region Check
        if (utils.isNullOrEmpty(field.dataMember)) {
            return;
        }
        // #endregion
        // #region Rule
        delete this._rules[field.dataMember];
        // #endregion
    }
    registerValue(member, value) {
        if (!this._data.hasOwnProperty(member)) {
            utils.setObjectValue(this._data, member, value);
        }
    }
    // #endregion
    // #region Event-Callbacks
    validateField(field) {
        // #region Check
        if (utils.isNullOrEmpty(field.dataMember)) {
            return;
        }
        // #endregion
        // #region Run
        this.validateValue(field.dataMember);
        // #endregion
    }
    validateValue(name) {
        // #region Init
        if (this._rules[name] === undefined) {
            return;
        }
        // #endregion
        // #region Run
        //Find
        let tTask = this._rules[name];
        let tValue = tTask.getValue();
        let tIsSucceeded = true;
        let tMessage = '';
        //Run
        tTask.rules.forEach(e => {
            if (!tIsSucceeded) {
                return;
            }
            // #region Function
            //if (typeof e.props === 'function') {
            //    let result = e.props(this._component, task.value, (error: any) => {
            //        this.addResult(validation, error);
            //    });
            //    if (utils.isPromise(result)) {
            //        result.then(() => {
            //            this.addResult(validation, undefined);
            //        }).catch((error: any) => {
            //            this.addResult(validation, error.statusText);
            //        });
            //        return true;
            //    }
            //    this.addResult(validation, result);
            //    return true;
            //}
            // #endregion
            // #region Validator
            if (!this._Validator.has(e.name)) {
                utils.logError('ValidationManager', `Validation-rule "${e.name}" not found`);
                return false;
            }
            let tValidation = {
                name: e.name,
                displayName: tTask.displayName,
                path: name,
                time: Date.now(),
                task: undefined,
            };
            let tValidator = this._Validator.get(e.name);
            let tResult = tValidator.validate(tValidation, e, tValue, this.data, this);
            // #endregion
            // #region Result
            if (!tResult.isSucceeded) {
                tIsSucceeded = false;
                tMessage = tResult.message ?? '';
            }
            // #endregion
        });
        // #endregion
        // #region Result
        if (!tIsSucceeded) {
            tTask.message = tMessage;
            tTask.isValidated = true;
            tTask.isValid = false;
        }
        else {
            tTask.message = undefined;
            tTask.isValidated = true;
            tTask.isValid = true;
        }
        //Callback
        tTask.setValidation();
        //Set
        tTask.isValidated = true;
        tTask.validatedAt = Date.now();
        // #endregion
    }
    // #endregion
    // #region Core
    isValid() {
        //Vars
        let tHasError = false;
        //RUn
        Object.keys(this._rules).forEach(e => {
            if (!this._rules[e].isValid) {
                tHasError = true;
                return;
            }
        });
        return !tHasError;
    }
    message(name) {
        if (this._rules[name] === undefined) {
            return '';
        }
        return this._rules[name].message;
    }
    validate() {
        // #region Reset
        Object.keys(this._rules).forEach(e => {
            //System
            if (e.startsWith("$")) {
                delete this.rules[e];
            }
            //Value
            else {
                this.validateValue(e);
            }
        });
        // #endregion
        // #region Validate
        return this.isValid();
        // #endregion
        return false;
    }
    setError(name, message) {
        //Run
        this._rules[name] = {
            name: name,
            displayName: name,
            isValidated: true,
            isValid: false,
            message: message,
            getValue: () => { return null; },
            setValidation: () => { },
            updateValue: () => { },
            rules: [],
        };
    }
}
